var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavoris = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B2B2",
  fillRule: "evenodd",
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M12.025 2.513c-.143 0-.326.063-.408.241L9.179 8.021a.924.924 0 0 1-.7.512l-5.6.868a.417.417 0 0 0-.347.273.344.344 0 0 0 .087.357l4.17 4.334c.186.195.27.457.229.719l-.967 6.01c-.033.197.103.314.162.356.12.084.317.133.51.024l4.828-2.705a.985.985 0 0 1 .948 0l4.828 2.705c.194.11.39.059.51-.024.059-.041.194-.159.163-.357l-.966-6.008a.834.834 0 0 1 .228-.72l4.17-4.333a.345.345 0 0 0 .086-.359.419.419 0 0 0-.347-.272l-5.599-.868a.92.92 0 0 1-.7-.513l-2.438-5.266c-.082-.178-.265-.241-.409-.241m5.538 19.512a.97.97 0 0 1-.475-.126l-4.826-2.705a.497.497 0 0 0-.473 0L6.963 21.9a.976.976 0 0 1-1.03-.05.837.837 0 0 1-.363-.834l.966-6.009a.36.36 0 0 0-.1-.304L2.267 10.37a.829.829 0 0 1-.198-.852.91.91 0 0 1 .735-.599l5.6-.868a.437.437 0 0 0 .333-.237l2.437-5.265a.922.922 0 0 1 .851-.524c.376 0 .702.201.852.524l2.438 5.266a.435.435 0 0 0 .332.236l5.598.868a.91.91 0 0 1 .735.598c.102.3.028.619-.196.853l-4.17 4.333a.351.351 0 0 0-.1.303l.967 6.01a.84.84 0 0 1-.365.834.966.966 0 0 1-.553.175"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavoris);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favoris.121d801f132d98ed66e18ea296bde796.svg";